import React from "react";
import { Col, Row } from "react-bootstrap";
import { SiPlaywright } from "react-icons/si";
import { FaNetworkWired, FaCogs } from "react-icons/fa";
import { MdOutlinePhoneIphone } from "react-icons/md";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiPlaywright size={48} />
        <div className="tech-icons-text">Test Automation (Playwright)</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <MdOutlinePhoneIphone size={48} />
        <div className="tech-icons-text">Mobile Automation (Appium)</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <FaNetworkWired size={48} />
        <div className="tech-icons-text">API & Data-Driven Testing</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <FaCogs size={48} />
        <div className="tech-icons-text">CI/CD & Test Infrastructure</div>
      </Col>
    </Row>
  );
}

export default Toolstack;
